import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { FixedToolMeasurement } from '../fixed-tool-measurement';

export class FixedToolMeasurementBuilder {
  static fromJson(json) {
    return (json)
      ? new FixedToolMeasurement(
        json.hash,
        json.modelHash,
        json.modelName,
        json.modelReference,
        json.toolHash,
        json.toolName,
        json.toolHolderHash,
        json.toolHolderName,
        parseNumber(json.length),
        parseNumber(json.z),
        parseNumber(json.x),
        parseNumber(json.concentricity)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(FixedToolMeasurementBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/fixed-tool-measurement.builder.ts